<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="10"
        sm="4"
      >
        <v-card>
          <v-card-title class="text-h3">
            Выберите организацию
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-list dense>
              <v-list-item-group
                v-model="selectedItem"
                color="primary"
                @change="onChooseItem"
              >
                <v-list-item
                  v-for="(item) in customers"
                  :key="item.value"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-center">
            <v-btn
              color="primary"
              outlined
              @click="onCancel"
            >
              Отмена
            </v-btn>
            <v-btn
              color="primary"
              @click="onSave"
            >
              Выбрать
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "@/views/loyalty/shared/modules/web_api"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"

export default {
  name: "UserProfileCompanyList",
  data: () => ({
    customerId: null,
    customerName: null,
      customerNumber: null,
    customers: [{ value: '', text: '' }],
    justpayClient: null,
    selectedItem: 0,
      userprofileService: null,
    webApi: null,
  }),
  async mounted () {
      this.userprofileService = new Userprofile()
    const userProfileId = localStorage.getItem('userProfileId')
    const customerId = localStorage.getItem('customer')
    this.webApi = new WebApi(this.$store)
    this.justpayClient = new JustpayClient()
    // const customers = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/user_profile/customer/${userProfileId}`)
      const customerNumbers = await this.userprofileService.getCustomerNumbers(userProfileId)
    console.log('customerNumbers:', customerNumbers)
    this.customers = await Promise.all(customerNumbers.map(async customerNumber => {
      return this.justpayClient.getClient(customerNumber)
    }))
    console.log('this.customers:', this.customers)
  },
  methods: {
    onCancel () {
      this.$router.push({ name: 'Crowd' })
    },
    async onChooseItem () {
      if (this.selectedItem !== undefined) {
        console.log('this.selectedItem=' + this.selectedItem)
        console.log('customer=', this.customers[this.selectedItem].value)
        this.customerId = this.customers[this.selectedItem].value
        this.customerName = this.customers[this.selectedItem].text
          this.customerNumber = await this.justpayClient.getClientNumber(this.customers[this.selectedItem].value)
      }
    },
    onSave () {
      if (this.customerId) {
        localStorage.setItem('customer', this.customerId)
          localStorage.setItem('customerNumber', this.customerNumber)
        this.$router.push({ name: 'Crowd', query: { customerName: this.customerName } })
      }
    }
  }
}
</script>

<style scoped>

</style>
